<div class="flex flex-col gap-2 px-[8px]">
  <div class="filter-container rounded-2xl p-[16px] filters-shadow">
    <div class="flex flex-col gap-2 pb-3">
      <div class="mb-6 flex flex-col gap-6">
        <div class="grid grid-cols-4 gap-6">
          <app-filter-item-search
            [label]="reasonNameLabel"
            [placeholder]="reasonNamePlaceholder"
            [(searchTerm)]="searchTerm"></app-filter-item-search>
        </div>

        <div class="grid grid-cols-4 gap-6">
          <app-filter-date-component
            [label]="fromDateLabel"
            [(value)]="fromDate"
            [isInvalid]="
              fromDate() !== null && toDate() !== null && fromDate()! > toDate()!
            "></app-filter-date-component>

          <app-filter-date-component
            [label]="toDateLabel"
            [(value)]="toDate"
            [isInvalid]="
              fromDate() !== null && toDate() !== null && fromDate()! > toDate()!
            "></app-filter-date-component>

          <app-filter-date-component
            [label]="lastUpdatedOnFromLabel"
            [(value)]="lastUpdatedOnFrom"
            [isInvalid]="
              lastUpdatedOnFrom() !== null && lastUpdatedOnTo() !== null && lastUpdatedOnFrom()! > lastUpdatedOnTo()!
            "></app-filter-date-component>

          <app-filter-date-component
            [label]="lastUpdatedOnToLabel"
            [(value)]="lastUpdatedOnTo"
            [isInvalid]="
              lastUpdatedOnFrom() !== null && lastUpdatedOnTo() !== null && lastUpdatedOnFrom()! > lastUpdatedOnTo()!
            "></app-filter-date-component>
        </div>
      </div>

      <div class="filter-divider mt-3 mb-5 h-px w-full"></div>

      <div class="flex items-end justify-between gap-3 pt-4">
        <app-filter-sorting-component
          [orderBy]="orderBy()"
          (orderByChange)="onOrderByChange($event)"
          [orderDir]="filters().orderDir"
          [sortOptions]="sortOptions()"
          (toggleOrder)="toggleSortOrder()"></app-filter-sorting-component>

        <div class="flex gap-2">
          <app-submit-button (click)="onResetFilters()">
            <span i18n="@@adminProductsResetButton">Clear</span>
          </app-submit-button>
          <app-submit-button type="primary" (click)="onApplyFilters()">
            <span i18n="@@adminProductsApplyButton">Apply</span>
          </app-submit-button>
        </div>
      </div>
    </div>
  </div>
  @if (loading()) {
    <div class="flex justify-center py-12">
      <app-loading />
    </div>
  } @else if (errorGettingRejectionReasons()) {
    <app-error [apiError]="errorGettingRejectionReasons()!" />
  } @else {
    <div class="table-container mt-2 overflow-visible rounded-[8px] border bg-white shadow-sm">
      <app-tables
        [headerItems]="headerItems()"
        [rows]="rows()"
        [currentActions]="actions()"
        [emptyFilterTitle]="emptyStateMessage()"
        [emptyContentTitle]="emptyStateMessage()"
        (actionTrigger)="onActionTrigger($event)" />

      <app-pagination
        [currentPage]="currentPage()"
        [getPageNumbers]="pageNumbers()"
        [totalPages]="totalPages()"
        [startItem]="startItem()"
        [endItem]="endItem()"
        [totalItems]="totalItems()"
        (previousPage)="onPreviousPage()"
        (nextPage)="onNextPage()"
        (goToPage)="onGoToPage($event)" />
    </div>
  }
</div>

@if (showDeleteDialog()) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="deleteTitle"
    [description]="deleteDescription"
    [confirmContent]="confirmButton()"
    [cancelContent]="cancelButton"
    (onCancel)="onCancelDelete()"
    (onSubmit)="onConfirmDelete()"
    [error]="deleteErrorMessage()" />
}
@if (showSuccessNotification()) {
  <app-successful-notification [type]="'success'" [title]="deleteSuccessMessage()" />
}
